import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class PackingMethodCapacityRequest {
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    noOfPouches: number;
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    pouchesPerRow: number;
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    uomId: number;
    @ApiProperty()
    packingMethodId?: number;

}